<template>
  <b-row>
    <b-col
      v-for="kpi in cards"
      :key="kpi.key"
      cols="12"
      sm="6"
      md="4"
      xl="2"
      class="mb-1"
    >
      <b-card no-body class="mb-0">
        <b-card-body class="d-flex align-items-center p-1">
          <div
            class="rounded p-1 mr-1 d-flex align-items-center justify-content-center"
            :class="`bg-light-${kpi.color}`"
            style="width:42px;height:42px;flex-shrink:0"
          >
            <feather-icon
              :icon="kpi.icon"
              size="18"
              :class="`text-${kpi.color}`"
            />
          </div>
          <div class="overflow-hidden">
            <h4 class="font-weight-bolder mb-0 text-truncate">{{ kpi.value }}</h4>
            <small class="text-muted">{{ kpi.label }}</small>
          </div>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BCard, BCardBody } from 'bootstrap-vue'

export default {
  name: 'PerfKpiCards',
  components: { BRow, BCol, BCard, BCardBody },
  props: {
    cards: { type: Array, default: () => [] },
  },
}
</script>
